import './MoreButton.css';

import React, { useState, useEffect, useRef } from 'react';
import CustomButton from './CustomButton';
import { generateClassName } from './helpers';

// CAREFUL: This component is not a button, but a container for a button and a dropdown menu
// WARNING: The Confirm feature of the CustomButton is not working when using it inside the MoreButton

const MoreButton = ({ label = "", icon, buttons, dropPositionAlign = 'left', className = null, theme = null, ...props }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState(dropPositionAlign);
    const containerRef = useRef(null);

    const handleToggleDropdown = (event) => {
        event.stopPropagation();
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setIsDropdownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (isDropdownOpen && containerRef.current) {
            const rect = containerRef.current.getBoundingClientRect();
            const isCloseToRightEdge = rect.right + 200 > window.innerWidth; // Assuming dropdown width is 200px
            if (dropdownPosition === 'left') {
                setDropdownPosition(isCloseToRightEdge ? 'right' : 'left');
            }
        }
    }, [isDropdownOpen]);

    const handleClick = (event, buttonProps) => {
        event.stopPropagation();
        buttonProps.onClick && buttonProps.onClick(event);
        setIsDropdownOpen(false);
    };

    return (
        <div className={generateClassName("more-button", `-container ${theme ? theme : ''}`, className)} ref={containerRef}>
            <CustomButton
                label={label}
                icon={icon}
                onClick={handleToggleDropdown}
                className="more-button"
                {...props}
            />
            {isDropdownOpen && (
                <div className={`dropdown-menu ${dropdownPosition}`}>
                    {buttons.map((buttonProps, index) => (
                        <CustomButton key={index} {...buttonProps}
                            onClick={(event) => {
                                handleClick(event, buttonProps);
                            }}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default MoreButton;